import React, { useState, useEffect, useRef } from "react";
import headerProfile from "../../assets/images/default-user.svg";

const HeaderProfile = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstName: "--",
    lastName: "--",
    mobile: "--",
    email: "--",
  });

  const modalRef = useRef(null);
  const profileContainerRef = useRef(null); // Added reference for profile container

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    // Close modal if clicked outside both the modal and the profile container
    if (
      modalRef.current && !modalRef.current.contains(event.target) &&
      profileContainerRef.current && !profileContainerRef.current.contains(event.target)
    ) {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    const loggedInDetails = localStorage.getItem("LoggedInDetails");
    if (loggedInDetails) {
      const parsedDetails = JSON.parse(loggedInDetails);
      const [firstName, lastName] = parsedDetails?.full_name?.split(" ");
      setUserDetails({
        firstName: firstName || "--",
        lastName: lastName || "--",
        mobile: parsedDetails.mobile_no || "--",
        email: parsedDetails.username || "--",
      });
    }
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isModalOpen]);

  return (
    <div style={{ position: "relative" }}>
      {/* Profile Header */}
      <div
        className="header-profile-container"
        ref={profileContainerRef} // Reference for profile container
        onClick={toggleModal}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px",
        }}
      >
        <img
          height="30px"
          width="30px"
          src={headerProfile}
          alt="Profile"
          style={{ borderRadius: "50%" }}
        />
        <span style={{ fontSize: "16px", fontWeight: "500" }}>
          Hi, {userDetails.firstName}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            width: "20px",
            height: "20px",
            transform: isModalOpen ? "rotate(180deg)" : "rotate(0)",
            transition: "transform 0.3s ease",
          }}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="modal"
          ref={modalRef} // Modal reference
          style={modalStyles}
        >
          <div style={modalBodyStyles}>
            <p>
              <strong>First Name:</strong> {userDetails.firstName|| "--"}
            </p>
            <p>
              <strong>Last Name:</strong> {userDetails.lastName || "--"}
            </p>
            <p>
              <strong>Mobile:</strong> {userDetails.mobile || "--"}
            </p>
            <p>
              <strong>Email ID:</strong> {userDetails.email || "--"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

// Modal Styles
const modalStyles = {
  position: "absolute",
  top: "65px",
  right: "0",
  backgroundColor: "#FFF1E9",
  borderRadius: "8px",
//   border: "1px solid #000",
  boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
  zIndex: 1000,
  width: "180%",
  overflow: "hidden",
  animation: "fadeIn 0.3s ease-in-out",
};

const modalHeaderStyles = {
  backgroundColor: "#f5f5f5",
  padding: "10px",
  borderBottom: "1px solid #ddd",
  textAlign: "center",
};

const modalBodyStyles = {
  padding: "15px",
};

const modalFooterStyles = {
  padding: "10px",
  borderTop: "1px solid #ddd",
  textAlign: "center",
};

const closeButtonStyles = {
  backgroundColor: "#FF8033",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  padding: "8px 16px",
  cursor: "pointer",
  fontSize: "14px",
};

export default HeaderProfile;
